module.exports = __webpack_public_path__ + "img/6.d3b7ee94.jpg";